import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getProcessesContentData, getProcessesContentPikuahBniaData, getProcessesTitleData, getProcessesTitlePikuahBniaData } from '../../server/ServerFunc';

import CustomePanelAndTable from './CustomeProcessPanelAndTable';
import ProcessInfo from './ProcessInfo';
import PageBar from '../../CustomeComponents/PageBar';
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';

const ProcessInfoContainer = ({ isSeparate }) => {
    const [processesTikNum, setProcessesTikNum] = useState("");
    const [processesTitles, setProcessesTitles] = useState([]);
    const [processesContentList, setProcessesContentList] = useState([]); //NEDD?? 
    const [processesArrayData, setProcessesArrayData] = useState([]);
    const [systemCode, setSystemCode] = useState("");
    const [tikNumStr, setTikNumStr] = useState("");
    const [compDate, setCompDate] = useState("");
    const [isMobile, setIsMobile] = useState(false);

    const search = useLocation().search;

    useEffect(() => {
        const tikNumURL = new URLSearchParams(search).get("TikNum");
        const systemCodeURL = new URLSearchParams(search).get("SystemCode");
        getProcessesTitle(tikNumURL, systemCodeURL);
    }, []);

    useEffect(() => {
        const tikNumURL = new URLSearchParams(search).get("TikNum");
        const systemCodeURL = new URLSearchParams(search).get("SystemCode");
        if (processesTitles.length > 0) {
            getProcessesContent(tikNumURL, systemCodeURL);
        }
    }, [processesTitles]);

    const getProcessesTitle = async (tikNum, systemCode) => {
        let titlesList = [];
        if (systemCode !== "26400056") {
            titlesList = await getProcessesTitleData(tikNum, systemCode);
        } else {
            titlesList = await getProcessesTitlePikuahBniaData(tikNum);
        }
        if (titlesList.length > 0) {
            setProcessesTitles(titlesList);
        } else {
            setProcessesTitles([]);
        }
        setProcessesTikNum(tikNum);
    }

    const getProcessesContent = async (tikNum, sysCode) => {
        const processCode = null;
        let processesList = [];
        if (sysCode !== "26400056") {
            processesList = await getProcessesContentData(sysCode, tikNum, processCode);
        } else {
            processesList = await getProcessesContentPikuahBniaData(tikNum);
        }
        if (processesList.length > 0) {
            setProcessesContentList(processesList);
            createProcessDictionary(processesList);
        } else {
            setProcessesContentList([]);
        }
        setSystemCode(sysCode);
        setTikNumStr(tikNum);
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        setCompDate(`${day}/${month}/${year}`);
        setIsMobile(window.innerWidth < 768);
    }

    const createProcessDictionary = (processesStepsList) => {
        const proStepsList = processesStepsList;
        const proTitlesList = processesTitles

        // Initialize an empty dictionary
        const processDictionary = {};
        // Iterate over the processes array and populate the dictionary
        proTitlesList.forEach(process => {
            const { processCode, processTitle } = process;
            // Find steps related to the current processCode
            const relatedSteps = proStepsList.filter(step => step.processCode === processCode);
            if (relatedSteps.length > 0) {
                // Add entry to the dictionary
                processDictionary[processCode] = {
                    processTitle,
                    proStepsList: relatedSteps
                };
            }
        });
        displayDictionaryData(processDictionary)
    }

    const displayDictionaryData = (dictionaryProcesses) => {
        const convertedDictionaryArray = [];
        let countExpend = 0;

        if (Object.keys(dictionaryProcesses).length > 0) {
            let arrLength = Object.keys(dictionaryProcesses).length;
            for (const proCode in dictionaryProcesses) {
                if (dictionaryProcesses.hasOwnProperty(proCode)) {
                    const { processTitle, proStepsList } = dictionaryProcesses[proCode];
                    convertedDictionaryArray.push({
                        id: `.${countExpend}`,
                        title: processTitle,
                        key: countExpend,
                        expanded: countExpend === arrLength - 1 ? true : false,
                        content: <CustomePanelAndTable key={proCode} processTitle={processTitle} proStepsList={proStepsList} 
                                    tikNum={processesTikNum} isExpend={countExpend} panelBarLength={arrLength}
                                />
                    })
                }
                countExpend++;
            }
        } else {
            convertedDictionaryArray.push({
                id: `.${countExpend}`,
                title: "",
                key: countExpend,
                expanded: true,
                content: <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
            })
        }
        setProcessesArrayData(convertedDictionaryArray) //Data - Array
    }

    const TitleProcessComp = () => {
        
        return (
            <div id="tikToPrint" style={{ margin: "-10px 15px" }} > {/* style={{ visibility: 'hidden', width: "1200px" }} */}
                <PageBar className="container my-3" >
                    <div className="d-flex gap-4" style={{ margin: "10px 0px", fontSize: "larger"}}>
                        <span style={{ zIndex: -1 }}> {/* style={{ zIndex: -10 }} */}
                            <span><b>תיק: </b></span>
                            <span>{`${tikNumStr}`}</span>
                        </span>
                        <span style={{ zIndex: -1 }}>
                            {/* <span><b>כותרת: </b></span> */}
                            <span>,תהליך בתיק,</span>
                        </span>
                        <span style={{ zIndex: -1 }}>
                            <span><b>תאריך: </b></span>
                            <span>{compDate}</span>
                        </span>
                    </div>
                </PageBar>
            </div>
        )
    }

    return (
        systemCode === "26400046" ?
            <div style={{ margin: `${isMobile? "-105px 0px 0px 0px": (!isSeparate ? "-112px 0px 0px 0px" : "")}`, backgroundColor: "white" }}>
                { isSeparate && <AppHeaderGlobal />}
                {processesArrayData.length > 0 && <ProcessInfo PanelBarItemsExt={processesArrayData} systemCode={systemCode} isMobile={isMobile} />}
                { isSeparate && <AppFooter /> }
            </div>
            :
            systemCode === "26400001" ?
                // <div style={{ margin: "0px", backgroundColor: "white" }}>
                //     {
                        processesArrayData.length > 0 && (
                        <>
                            { isSeparate && <AppHeaderGlobal />}
                            { !isSeparate && <TitleProcessComp /> }
                            <div style={{ margin: `${isMobile? "-105px 0px 0px 0px": (!isSeparate ? "-112px 0px 0px 0px" : "")}`, backgroundColor: "white" }}>
                                <ProcessInfo PanelBarItemsExt={processesArrayData} systemCode={systemCode} isMobile={isMobile} />
                            </div>
                            { isSeparate && <AppFooter /> }
                        </>)
                //     }
                // </div>
                :
                processesArrayData.length > 0 && <ProcessInfo PanelBarItemsExt={processesArrayData} />
    )
}

export default ProcessInfoContainer